import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";

export const getShoppableVideoDetails = createAsyncThunk(
    "shoppable/getShoppableVideoDetails",
    async (arg, thunkAPI) => {
        return await APIV2(`user/v1/video/api/view-video?videoId=${arg}`, "GET", {}, "JAVA")
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }
);

let initialState = {
    userId: null,
};

export const shoppableSlice = createSlice({
    name: "shoppable",
    initialState,
    reducers: {
        setUserId: (state, action) => {
            state.userId = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const { setUserId } = shoppableSlice.actions;

export default shoppableSlice.reducer;
